import { useContext } from 'react';
import { AppContext } from '../../../bootstrap/App';
import CustomUserData from '../models/CustomUserData';
import { UserLanguage } from '../enums/UserLanguage';
import { UserRegionalFormat } from '../enums/UserRegionalFormat';
import { UserRole } from '../enums/UserRole';
import { UserTheme } from '../enums/UserTheme';
import { BoutiquesView } from '../../boutiques/models/Boutique';
import { UserCrmChoice } from '../enums/UserCrmChoice';

/**
 * Get the username of the current signed-in user
 */
function useGetCurrentUser(): CustomUserData {
  const { user } = useContext(AppContext);

  const userId = user?.id;
  const data = user ? (user as unknown as Partial<CustomUserData>) : undefined;

  return {
    _id: userId ?? '',
    email: data?.email ?? '',
    name: data?.name ?? '',
    createdAt: data?.createdAt ?? new Date(),
    updatedAt: data?.updatedAt,
    theme: data?.theme ?? UserTheme.Light,
    language: data?.language ?? UserLanguage.ENGLISH,
    regionalFormat: data?.regionalFormat ?? UserRegionalFormat.ENGLISH_US,
    // TODO : SF - Delete the crm choice
    crmChoice: data?.crmChoice ?? UserCrmChoice.SUGAR,
    roles: data?.roles ?? [UserRole.COLLABORATOR],
    alertShown: data?.alertShown ?? [],
    boutique: data?.boutique ?? '',
    bookingCalendar: data?.bookingCalendar ?? undefined,
    welcomeWizardCompleted: data?.welcomeWizardCompleted ?? false,
    boutiquesView: data?.boutiquesView ?? BoutiquesView.Table,
  };
}

export default useGetCurrentUser;
